<template>
    <sa-page-layout>
        <template slot="toolbar">
            <b-button variant="secondary btn-toolbar float-sm-right sa-margin-right" size="sm"
                @click="onClickTornaAllaLista"><i class="fas fa-list"></i>Torna alla lista</b-button>
        </template>
        <template slot="table-body">

            <AccettazioneSsnSchedaPazienteComponent ref="cmpAccettazioneSsnSchedaPazienteComponent" />

        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import UtilityMixin from "../../../utility/UtilityMixin";
import AccettazioneSsnSchedaPazienteComponent from "../components/AccettazioneSsnSchedaPazienteComponent.vue"

export default {
    mixins: [UtilityMixin],
    components: { SaPageLayout, AccettazioneSsnSchedaPazienteComponent },
    data() {
        return {
            id: null,
            jsonData: {},
            pathResource: "/accettazionessn",
        }
    },
    mounted() {
        if (!this.$route.params.id) {
            this.$router.push("/nuovaaccettazionessn")
        }
        this.id = this.$route.params.id;
        console.log(this.id);

        this.loadDataSchedaPazienteAccettazione();
    },
    methods: {
        onClickTornaAllaLista() {
            this.$router.push("/nuovaaccettazionessn");
        },
        loadDataSchedaPazienteAccettazione() {
            this.loadDataResources(this.pathResource + "/" + this.id, {}, this.loadDataSchedaPazienteAccettazioneSuccess, null);
        },
        loadDataSchedaPazienteAccettazioneSuccess(response) {
            this.$refs.cmpAccettazioneSsnSchedaPazienteComponent.init(response.data.data)
        }
    }

}
</script>

<style lang="scss" scoped></style>